import http from "../http-common";

class EmailService {

    sendEmail(data) {
        return http.post("/email", data);
    }

    sendEmailAuditoria(data) {
        return http.post("/email/mailauditoria", data);
    }
}

export default new EmailService();